"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
exports.PolygonConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Polygon,
    chainId: Types_1.EthChainIds.Polygon,
    publicRpc: "https://polygon-rpc.com",
    nativeToken: Tokens_1.MATICNativeToken,
    wrappedToken: Tokens_1.MATICWrappedToken,
    upToken: Tokens_1.MATICUpToken,
    unfiToken: Tokens_1.MATICUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmSwnuGtuLGyP7kGuW8oQhn8oHEFKuaAcYA7HBRNQtWvtm",
    multicall: {
        supported: true,
        address: "0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://polygonscan.com",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [MetamaskConnector_1.MetamaskConnector, MetamaskCompatibleConnector_1.MetamaskCompatibleConnector, WalletConnectConnector_1.WalletConnectConnector], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.Polygon, "https://polygon-rpc.com"),
]);
